<template>
    <label class="relative inline-flex items-center cursor-pointer">
        <input type="checkbox" @change="changeChecked" :checked="value" class="sr-only peer">
        <div :class="{ 'w-11 h-6': size == 'medium', 'w-8 h-4': size == 'small' }"
            class=" bg-gray-200 rounded-full peer peer-focus:ring-2 peer-focus:ring-green-300   peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-success">
        </div>
        <span class="ml-3 text-sm">{{ label }}</span>
    </label>
</template>
<script>
export default defineComponent({
    props: {
        value: {
            type: Boolean
        },
        label: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: "medium"
        }
    },
    data() {
        return {

        }
    },
    methods: {
        changeChecked(e) {
            this.$emit('update:value', e.target.checked)
        }
    }
})
</script>